import { Component } from "@angular/core";
import { IEmployeeSimpleModel } from "../shared/models/roster/employee-simple-model";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { IRosterDataClearModel } from "../shared/models/roster/roster-data-clear-model";
import { PpsUtilityService } from "../services/pps-utility.service";

@Component({
  selector: "delete-roster-data-form" ,
  templateUrl: "./delete-roster-data-form.component.html"
})
export class DeleteRosterDataFormComponent{
  fromDate: Date = new Date();
  employees: IEmployeeSimpleModel[] = [];
  selectedEmployees: IEmployeeSimpleModel[] = [];
  deletionNote: string = "";
  errorMessage: string = "";

  constructor(    
    private _util: PpsUtilityService,
    private _dialogRef: DynamicDialogRef,    
    private _dialogConfig: DynamicDialogConfig){
    this.employees = _dialogConfig.data.employees;
  }

  cancel(){
    this._dialogRef.close();
  }

  delete(){
    let rosterDataClearModel:IRosterDataClearModel = {
      startDate: this.fromDate,
      employees: this.selectedEmployees.map(e => e.id),
      note: this.deletionNote
    };

    if (rosterDataClearModel.employees.length === 0){
      this.errorMessage = "Must select one or more employees to continue";
      return;
    }

    let selectedEmps = this.selectedEmployees.map(e => this._util.getEmployeeName(e)).join("; ");
    this._dialogRef.close({deletionModel: rosterDataClearModel, selectedEmployees: selectedEmps});
  }
}